import React from 'react';
import PropTypes from 'prop-types';

function SuccessMessage({ message, onDismiss, className, title = 'Success' }) {
  if (!message) return null;

  return (
    <div
      className={`flex items-start gap-3 rounded-[12px] border-[1.5px] border-[#C5E5D0] bg-[#F3FAF5] px-4 py-3.5 ${className || ''}`}
      role='status'
    >
      <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#1A7A4A]'>
        <svg width='17' height='17' viewBox='0 0 24 24' fill='none' stroke='#fff' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
          <circle cx='12' cy='12' r='10' />
          <path d='M8 12.5l2.5 2.5L16 9.5' />
        </svg>
      </div>
      <div className='min-w-0 flex-1 pt-0.5'>
        <div className='text-sm font-semibold leading-5 text-[#0B1929]'>{title}</div>
        <div className='mt-0.5 text-[13px] leading-5 text-[#2F5C45]'>{message}</div>
      </div>
      {onDismiss ? (
        <button
          type='button'
          onClick={onDismiss}
          className='-mr-1 -mt-0.5 inline-flex shrink-0 rounded-md p-1.5 text-[#5A8A6E] transition hover:bg-[#E5F3EA] hover:text-[#0B1929] focus:outline-none focus:ring-2 focus:ring-[#1A7A4A]/30'
          aria-label='Dismiss'
        >
          <svg className='h-4 w-4' viewBox='0 0 20 20' fill='currentColor' aria-hidden='true'>
            <path d='M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z' />
          </svg>
        </button>
      ) : null}
    </div>
  );
}

SuccessMessage.propTypes = {
  message: PropTypes.string,
  onDismiss: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string,
};

export default SuccessMessage;
